import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux'

import { AddressShape, AddressActionCreatorsShape as AddressActionCreators } from './propTypes'

import AddressDisplay from './AddressDisplay';
import { RadioInput } from '../../components';
import ActiveAddressInAddressSelectorListContainer from './ActiveAddressInAddressSelectorListContainer'

import {
  pretendAnchorStyle,
  softButtonStyle
} from '../../components'
import { TranslationUtility } from "../../../util/translationUtility";

class AddressSelectorList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeAddressId: '',
      disableBillingChanges: props.disableBillingChanges
    };

    this.onDeleted = this.onDeleted.bind(this);
    this.onSelected = this.onSelected.bind(this);
    this.onItemClick = this.onItemClick.bind(this);
    this.onRadioSelected = this.onRadioSelected.bind(this);
    this.translationUtility = new TranslationUtility(props.localizationItems);
  }

  beginEdit(Id) {
    if (this.state.activeAddressId !== '') {
      // Only set active if we had an active before
      this.setState({ activeAddressId: Id });
    }
    this.props.onBeginEdit(Id);
  }
  
  onRadioSelected(address) {
    this.setState({ activeAddressId: address.Id });
    this.props.onAddressSelected({ addressId: address.Id });
  }

  onSelected(address) {
    this.props.onAddressSelected({ addressId: address.Id });
    this.props.onDoneSelecting(address.Id);
    this.setState({ activeAddressId: '' });
  }

  onDeleted(id) {
    this.setState({ activeAddressId: '' });
  }
  
  onItemClick(id) {
    this.setState({ activeAddressId: id });
  }

  render() {
    const listComponent = this;
    const props = this.props;
    const listItems = this.props.addresses.map((address) => {
    const isSelected = props.selectedAddressId === address.Id;    
    const focused = listComponent.state.activeAddressId === address.Id;
      if (focused) {
        return (
          <ActiveAddressInAddressSelectorListContainer
              key={address.Id}
              address={address}
              selectAddressActionCreator={props.addressActionCreators.select}
              deleteAddressActionCreator={props.addressActionCreators.remove}
              selectAddressMessage={props.selectAddressMessage}
              onBeginEdit={(id) => listComponent.beginEdit(id)}
              isSelected={isSelected}
              onSelected={() => listComponent.onSelected(address)}
              onRadioSelected={() => listComponent.onRadioSelected(address)}
              onDeleted={() => listComponent.onDeleted(address.Id)}
              translationUtility={this.translationUtility}
          />
        );
      } else {
        return (
          <div
              key={address.Id}
              className='row'
              style={{ marginTop: 7, marginBottom: 7 }}
          >
            <div
                className='col-1'
                style={{ float: 'left', paddingLeft: 10, paddingRight: 10, paddingTop: 4, paddingBottom: 4 }}
            >
              <RadioInput
                  selected={isSelected}
                  onClick={
                    () => listComponent.onRadioSelected(address, listComponent.props.useForAnotherSelected)}
              />
            </div>
            <div
                className={`col-9 address ${isSelected ? 'selected' : ''}`}
            >
              <button
                style={softButtonStyle}
                onClick={(e) => { e.preventDefault(); listComponent.onItemClick(address.Id); }}
              >
                <AddressDisplay address={address} compact translationUtility={this.translationUtility}/>
              </button>
            </div>            
            {!this.state.disableBillingChanges && (typeof this.state.disableBillingChanges !== 'undefined') ? (<div className='col-2'>
                <a title='edit' href='' onClick={(e) => {
                    e.preventDefault();
                    listComponent.beginEdit(address.Id);
                }}>
                    <span
                        style={pretendAnchorStyle}
                        className='fa d-inline d-sm-none fa-edit'
                    />
                    <span
                        style={pretendAnchorStyle}
                        className='fa d-none d-sm-inline fa-2x fa-edit'
                    />
                </a>
            </div>) : (null)}
          </div>
        );
      }
    });

    return (
      <div className='container-fluid'>
        {listItems}
            {(!this.state.disableBillingChanges && (typeof this.state.disableBillingChanges !== 'undefined')) || (this.props.selectAddressMessage == 'Bill and Ship to this address' || this.props.selectAddressMessage == 'Ship to this address') || (typeof this.state.disableBillingChanges == 'undefined') ? (<button
                href='#'
                className='btn btn-default'
                style={{ marginTop: 15 }}
                onClick={() => this.beginEdit()}>{this.translationUtility.translateResourceString("/Checkout/Address/AddNew")}</button>) : (null)}
      </div>
    )
  }
}

AddressSelectorList.propTypes = {
  addressActionCreators: PropTypes.shape(AddressActionCreators).isRequired,
  addresses: PropTypes.arrayOf(AddressShape.propTypes).isRequired,
  onAddressSelected: PropTypes.func.isRequired,
  onDoneSelecting: PropTypes.func.isRequired,
  selectAddressMessage: PropTypes.string.isRequired,
  selectedAddressId: PropTypes.string,
  disableBillingChanges: PropTypes.bool,
  localizationItems: PropTypes.array.isRequired
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onAddressSelected: ({ addressId }) => dispatch(ownProps.addressActionCreators.select({ addressId }))
})

const mapStateToProps = state => ({
  localizationItems: state.constants.localizationItems
})

const AddressSelectorListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddressSelectorList)

export default AddressSelectorListContainer;


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Address/AddressSelectorList.jsx